import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../modules/shared/shared.module';
import { DropdownModule } from 'primeng/dropdown';
import { FormInputErrorModule } from "../form-input-error/form-input-error.module";
import { FormsModule } from '@angular/forms';
import { FormInputDropdownComponent } from './form-input-dropdown.component';

@NgModule({
  declarations: [
    FormInputDropdownComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    DropdownModule,
    FormInputErrorModule,
    FormsModule,
  ],
  exports: [
    FormInputDropdownComponent
  ]
})
export class FormInputDropdownModule { }
